import NumberFormat from 'react-number-format'

interface MascaraProps {
  inputRef: (instance: NumberFormat | null) => void
  onChange: (event: { target: { name: string; value: string } }) => void
  name: string
  decimalScale: number
  allowNegative: boolean
}

export const MascaraDecimal = ({ inputRef, onChange, decimalScale = 2, allowNegative = false, ...inputProps }: MascaraProps) => {
  return (
    <NumberFormat
      {...inputProps}
      getInputRef={inputRef}
      onValueChange={(values) => {
        onChange({
          target: {
            name: inputProps.name,
            value: values.value
          }
        })
      }}
      decimalScale={decimalScale}
      thousandSeparator="."
      decimalSeparator=","
      allowNegative={allowNegative}
      fixedDecimalScale
      isNumericString
    />
  )
}
